import { HttpClinet, baseURL, version } from "./../utils/config";

export const setpriceAPI = {
  getAllCategory: () => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/set_price/getAllCategory`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getSetPrice: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/set_price/getSetPrice`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...data },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getSetPriceExcel: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/set_price/getSetPriceExcel`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...data },
      responseType: "blob",
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  },
  getGroup_BU: (params) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/set_price/getGroup_BU`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      params,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getGroup_BUById: (id) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/set_price/getGroup_BU/${id}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  addGroup_BU: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/set_price/addGroup_BU`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  editGroup_BU: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/set_price/editGroup_BU`,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
};
